import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { AgentAssistHomeCard, HomeCard } from '../sections';
import { Heading, Subtitle } from '../components';
import { ReactComponent as IconRouting } from '../assets/iconDR.svg';
import { ReactComponent as IconCcs } from '../assets/iconCCS.svg';
import { ReactComponent as IconEc } from '../assets/iconEC.svg';

const HomeContainer = styled(Box)`
  align-items: start;
  max-width: 1499px;
  min-width: 500px;
`;

const Grid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(500px), 1fr));
  grid-gap: 24px;
  column-gap: 24px;
`;

function Home(props) {
  const { history } = props;
  return (
    <HomeContainer>
      <Heading>Welcome to Conversation Orchestrator</Heading>
      <Subtitle fontSize={2} mb={5}>
        LivePerson’s Conversation Orchestrator can help you personalize customer journeys at
        scale with Dynamic Routing, Conversation Context Service, and Agent Assist. You
        can configure, operate, and analyze key features here to give you  full control
        and transparency.
      </Subtitle>
      <Grid>
        <AgentAssistHomeCard history={history} />
        <HomeCard
          title="Dynamic Routing"
          history={history}
          Icon={IconRouting}
          content="Perform intelligent routing at scale. Create routing policies based on intent and context variables."
          buttons={[{ name: 'Manage Policies', route: '/intent-content-policies' }]}
        />
        <HomeCard
          title="Conversation Context Service (CCS)"
          history={history}
          Icon={IconCcs}
          content="Connect data from internal and external sources to power Dynamic Routing."
          buttons={[{ name: 'CCS', route: '/custom-context' }]}
        />
        <HomeCard
          title="Engagement Controller"
          history={history}
          Icon={IconEc}
          content="Create rules to dynamically display or hide web engagements."
          buttons={[{ name: 'Manage Rules', route: '/engagement-controller' }]}
        />
      </Grid>
    </HomeContainer>
  );
}

Home.defaultProps = {};

Home.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Home;
